import { connect } from 'react-redux';

import AuthComponent from '../next/auth';

const mapStateToProps = ({ auth, user }) => ({ auth, user });

export default connect(mapStateToProps, null)(AuthComponent);
